import { mapResourceTopologyIssue } from './prodResourceTopologyMappers';
import type {
  ResourceTopologyClientError,
  ResourceTopologyRequestFailure,
} from '../types/prodResourceTopology';

type RawRecord = Record<string, unknown>;

const asRecord = (value: unknown): RawRecord => (
  value && typeof value === 'object' ? value as RawRecord : {}
);

export const normalizeResourceTopologyError = (error: unknown): ResourceTopologyClientError => {
  const rawError = asRecord(error);
  const response = asRecord(rawError.response);
  const statusValue = response.status;
  const status = Number.isFinite(Number(statusValue)) ? Number(statusValue) : null;
  const body = asRecord(response.data);
  const details = asRecord(body.details);
  const message = typeof body.message === 'string' && body.message
    ? body.message
    : error instanceof Error ? error.message : '资源拓扑请求失败';

  if (status === 409 && body.code === 'TOPOLOGY_REVISION_CONFLICT') {
    return {
      kind: 'revision-conflict',
      message,
      expectedRevision: Number.isFinite(Number(details.expectedRevision))
        ? Number(details.expectedRevision)
        : null,
      actualRevision: Number.isFinite(Number(details.currentRevision))
        ? Number(details.currentRevision)
        : null,
    };
  }

  const issueValues = Array.isArray(details.issues)
    ? details.issues
    : details.issue
      ? [details.issue]
      : [];
  const failure: ResourceTopologyRequestFailure = {
    kind: 'request-failure',
    message,
    status,
    issues: issueValues.map(mapResourceTopologyIssue),
  };
  return failure;
};
